/* KINSŌ — pop-up de salida: 5% OFF a cambio del mail. Solo en el tema "Test A/B" (18/9/2026).

   CUÁNDO SALE: solo cuando la visitante toca "atrás" (decisión de Fede). En el celular no
   hay mouse que se vaya de la ventana, y el 84% del tráfico es Android, que se va con atrás.
   Truco: se agrega una entrada al historial; el "atrás" la consume, dispara popstate y ahí,
   en vez de irse, ve el pop-up. Si lo cierra se queda en la página, y el próximo atrás la
   saca de verdad. Chrome saltea en el "atrás" las entradas creadas sin que la persona haya
   tocado la página (intervención contra el secuestro del botón), así que la entrada se
   agrega en su PRIMER toque, no al cargar. A quien solo scrollea y se va no le sale.
   Clarity (18/9, 818 visitas): la mitad se va antes de los 35 s y sin pasar del 15% de la
   página, a la altura de los packs.

   NO SALE: si ya tocó un botón de compra (se está yendo a pagar, no a otro lado), si ya
   dejó el mail, o si ya lo vio en los últimos 7 días.

   EL MAIL: va a n8n (workflow 8s4lGv1MSeW4f6xt, fuente en n8n/popup-mail/), que lo carga en
   Shopify como clienta suscripta al email marketing con las etiquetas newsletter + popup-5off.
   NO por el formulario nativo de clientes: llamado desde un script, Shopify contesta 403
   "Verifying your connection..." (protección contra bots) y el mail se pierde. Va con
   sendBeacon, que no necesita CORS y sobrevive a que la página se cierre. "web" es un campo
   trampa invisible: si viene lleno es un bot y n8n lo descarta.
   EL DESCUENTO: /discount/KINSO5 deja el código puesto en la sesión y el checkout lo aplica
   solo. Código KINSO5: 5%, una vez por clienta.
   Eventos de Clarity: popup5_visto, popup5_mail, popup5_cerrado. */
(function () {
  if (!/kinso-parches-detox/.test(location.pathname)) return;
  var KEY = "kinso_pop5", CODIGO = "KINSO5", SEMANA = 7 * 864e5;
  var ALTA = "https://devwebhookn8n.kougarai.com/webhook/kinso-popup-mail";
  var st = {};
  try { st = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
  if (st.mail || (st.visto && Date.now() - st.visto < SEMANA)) return;

  function guardar() { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function evento(n) { try { if (window.clarity) window.clarity("event", n); } catch (e) {} }

  var compra = false, armado = false, usado = false;
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest('button[name="add"],.product-form__submit,#lkb-cta2,.lsa-btn')) compra = true;
  }, true);

  function armar() {
    if (armado) return;
    armado = true;
    try { history.pushState({ kinsoPop5: 1 }, "", location.href); } catch (e) {}
    ["pointerup", "touchend", "keydown"].forEach(function (t) { document.removeEventListener(t, armar, true); });
  }
  ["pointerup", "touchend", "keydown"].forEach(function (t) { document.addEventListener(t, armar, true); });

  window.addEventListener("popstate", function (e) {
    if (!armado || usado) return;
    if (e.state && e.state.kinsoPop5) return; /* volvió a NUESTRA entrada desde una posterior */
    usado = true;
    if (compra) { history.back(); return; } /* se iba igual: que siga sin frenarla */
    mostrar();
  });

  var css = ""
    + "#kp5{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:inherit}"
    + "#kp5 .kp5-bg{position:absolute;inset:0;background:rgba(18,26,12,.58);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;transition:opacity .3s}"
    + "#kp5 .kp5-s{position:relative;width:100%;max-width:460px;box-sizing:border-box;background:#fbf8f1;border-radius:22px 22px 0 0;padding:14px 22px calc(22px + env(safe-area-inset-bottom));"
    + "box-shadow:0 -18px 50px rgba(0,0,0,.25);transform:translateY(105%);transition:transform .42s cubic-bezier(.2,.9,.25,1.05);text-align:center;color:#1a1a1a}"
    + "#kp5.in .kp5-bg{opacity:1}#kp5.in .kp5-s{transform:none}"
    + "#kp5 .kp5-h{width:42px;height:4px;border-radius:9px;background:rgba(45,80,22,.2);margin:0 auto 16px}"
    + "#kp5 .kp5-x{position:absolute;top:10px;right:12px;width:36px;height:36px;border:0;background:transparent;font-size:24px;line-height:1;color:#7a7a7a;cursor:pointer}"
    + "#kp5 .kp5-e{font-size:11.5px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:#4a6b33;margin:0 0 8px}"
    + "#kp5 .kp5-t{font-size:25px;font-weight:900;line-height:1.12;margin:0 0 10px;letter-spacing:-.01em}"
    + "#kp5 .kp5-t b{color:#2d5016;background:linear-gradient(transparent 62%,rgba(212,175,55,.45) 62%);padding:0 2px}"
    + "#kp5 .kp5-p{font-size:14.5px;line-height:1.4;color:#4b4b4b;margin:0 auto 18px;max-width:340px}"
    + "#kp5 input{width:100%;box-sizing:border-box;font:inherit;font-size:16px;padding:15px 16px;border:1.5px solid rgba(45,80,22,.3);border-radius:12px;background:#fff;color:#1a1a1a;outline:none;margin:0 0 10px;text-align:left}"
    + "#kp5 input:focus{border-color:#2d5016;box-shadow:0 0 0 4px rgba(45,80,22,.12)}"
    + "#kp5 .kp5-b{width:100%;border:0;border-radius:999px;padding:17px 16px;font:inherit;font-size:15.5px;font-weight:900;letter-spacing:.04em;color:#fff;cursor:pointer;"
    + "background:linear-gradient(180deg,#3c6a20 0%,#2d5016 100%);box-shadow:0 10px 22px rgba(45,80,22,.32)}"
    + "#kp5 .kp5-b[disabled]{opacity:.6}"
    + "#kp5 .kp5-err{min-height:18px;font-size:13px;color:#b91c1c;margin:-2px 0 8px;text-align:left}"
    + "#kp5 .kp5-f{font-size:11.5px;color:#8a8a8a;margin:12px 0 0;line-height:1.35}"
    + "#kp5 .kp5-no{display:inline-block;margin-top:10px;border:0;background:none;font:inherit;font-size:13.5px;color:#7a7a7a;text-decoration:underline;cursor:pointer;padding:6px}"
    + "#kp5 .kp5-c{display:inline-block;font-size:20px;font-weight:900;letter-spacing:.18em;color:#2d5016;border:2px dashed rgba(45,80,22,.45);border-radius:12px;padding:10px 18px 10px 22px;margin:4px 0 16px;background:#fff}";

  function mostrar() {
    st.visto = Date.now(); guardar(); evento("popup5_visto");
    var s = document.createElement("style"); s.textContent = css; document.head.appendChild(s);
    var w = document.createElement("div"); w.id = "kp5";
    w.setAttribute("role", "dialog"); w.setAttribute("aria-modal", "true"); w.setAttribute("aria-labelledby", "kp5-t");
    w.innerHTML = '<div class="kp5-bg"></div><div class="kp5-s"><div class="kp5-h"></div>'
      + '<button type="button" class="kp5-x" aria-label="Cerrar">&times;</button>'
      + '<div class="kp5-in"><p class="kp5-e">Antes de irte</p>'
      + '<h2 class="kp5-t" id="kp5-t">Llevate <b>5% OFF extra</b> en tu pedido</h2>'
      + '<p class="kp5-p">Dejanos tu mail y te lo aplicamos ahora. Se suma al descuento del pack.</p>'
      + '<form novalidate><input type="email" name="email" inputmode="email" autocomplete="email" placeholder="Tu mail" aria-label="Tu mail">'
      + '<input type="text" name="web" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0">'
      + '<div class="kp5-err" aria-live="polite"></div>'
      + '<button type="submit" class="kp5-b">QUIERO MI 5% OFF</button></form>'
      + '<p class="kp5-f">Te escribimos solo con novedades y ofertas de KINSŌ. Te das de baja cuando quieras.</p>'
      + '<button type="button" class="kp5-no">No, gracias</button></div></div>';
    document.body.appendChild(w);
    var ov = document.documentElement.style.overflow; document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { requestAnimationFrame(function () { w.classList.add("in"); }); });

    function cerrar(n) {
      if (n) evento(n);
      w.classList.remove("in"); document.documentElement.style.overflow = ov;
      document.removeEventListener("keydown", esc);
      setTimeout(function () { w.remove(); }, 450);
    }
    function esc(e) { if (e.key === "Escape") cerrar("popup5_cerrado"); }
    document.addEventListener("keydown", esc);
    w.querySelector(".kp5-bg").onclick = function () { cerrar("popup5_cerrado"); };
    w.querySelector(".kp5-x").onclick = function () { cerrar("popup5_cerrado"); };
    w.querySelector(".kp5-no").onclick = function () { cerrar("popup5_cerrado"); };

    var f = w.querySelector("form"), inp = f.querySelector("input"), btn = f.querySelector("button"), err = f.querySelector(".kp5-err");
    f.onsubmit = function (e) {
      e.preventDefault();
      var mail = (inp.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { err.textContent = "Revisá el mail, parece que le falta algo"; inp.focus(); return; }
      err.textContent = ""; btn.disabled = true; btn.textContent = "UN SEGUNDO…";
      var body = new URLSearchParams({ email: mail, web: (f.querySelector('[name="web"]') || {}).value || "", origen: "popup-5off-testab" });
      var ok = false;
      try { ok = navigator.sendBeacon && navigator.sendBeacon(ALTA, body); } catch (x) {}
      if (!ok) { try { fetch(ALTA, { method: "POST", mode: "no-cors", body: body, keepalive: true }); } catch (x) {} }
      fetch("/discount/" + CODIGO, { credentials: "same-origin" }).catch(function () {})
        .then(function () {
          st.mail = Date.now(); guardar(); evento("popup5_mail");
          w.querySelector(".kp5-in").innerHTML = '<p class="kp5-e">Listo</p>'
            + '<h2 class="kp5-t" id="kp5-t">Tu <b>5% OFF</b> ya está aplicado</h2>'
            + '<p class="kp5-p">Se descuenta solo cuando pagás. Por las dudas, este es tu código:</p>'
            + '<div class="kp5-c">' + CODIGO + '</div>'
            + '<button type="button" class="kp5-b">VOLVER A MI PACK</button>';
          w.querySelector(".kp5-in .kp5-b").onclick = function () {
            cerrar();
            var sel = document.getElementById("linax-bundle-selector");
            if (sel) setTimeout(function () { sel.scrollIntoView({ behavior: "smooth", block: "center" }); }, 300);
          };
        });
    };
  }
})();
